export class Cmc {
  constructor({
    id = 0,
    orderId = 0,
    contractLength = 0,
    ratePlanId = 0,
    supervisorCost = 0,
    supervisorQuantity = 0,
    recordingCost = 0,
    recordingQuantity = 0,
    consoleCost = 0,
    consoleQuantity = 0,
    endUserQuantity = 0,
    endUserCost = 0,
    setupFee = 0,
  } = {}) {
    this.id = id;
    this.orderId = orderId;
    this.contractLength = contractLength;
    this.ratePlanId = ratePlanId;
    this.supervisorCost = supervisorCost;
    this.supervisorQuantity = supervisorQuantity;
    this.recordingCost = recordingCost;
    this.recordingQuantity = recordingQuantity;
    this.consoleCost = consoleCost;
    this.consoleQuantity = consoleQuantity;
    this.endUserQuantity = endUserQuantity;
    this.endUserCost = endUserCost;
    this.setupFee = setupFee;
  }
}
export function createCmc(data) {
  return Object.freeze(new Cmc(data));
}
